import Button from './Button.jsx';

export default Button;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/FilterGroupCollection/Button/index.js